/**
 * @module FE-CU25_カメラ画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import TabHeader from '../../components/tabHeader/TabHeader.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NotificationHistoryTimeline from '../../components/NotificationHistoryTimeline/NotificationHistoryTimeline.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU25';

export default {
  name: 'Camera',
  components: {
    Header,
    BreadCrumbList,
    TabHeader,
    MobileFooter,
    PcPageTitle,
    PCFooter,
    NotificationHistoryTimeline,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU25カメラ画面.カメラ'),
      isActive: true,
      camera01Image: require('../../assets/images/icon/camera01.png'),
      rushOrderAuthority01Image: require('../../assets/images/icon/rushOrderAuthority01.png'),
      notificationHistory01Image: require('../../assets/images/icon/notificationHistory01.png'),
      contactAuthority01Image: require('../../assets/images/icon/contactAuthority01.png'),
      deviceContorolAuthority01Image: require('../../assets/images/icon/deviceContorolAuthority01.png'),
      camera02Image: require('../../assets/images/icon/camera02.png'),
      rushOrderAuthority02Image: require('../../assets/images/icon/rushOrderAuthority02.png'),
      notificationHistory02Image: require('../../assets/images/icon/notificationHistory02.png'),
      contactAuthority02Image: require('../../assets/images/icon/contactAuthority02.png'),
      deviceContorolAuthority02Image: require('../../assets/images/icon/deviceContorolAuthority02.png'),
      cameraInfoList: [],
      tabNumber: null,
      tabs: [
        {
          id: 1,
          title: vm.$vuetify.lang.t('$vuetify.FECU25カメラ画面.カメラメニュー'),
        },
        {
          id: 2,
          title: vm.$vuetify.lang.t('$vuetify.FECU25カメラ画面.通知履歴ボタン'),
        },
      ],
      lastUpdate: '',
      // 通知履歴一覧を格納
      notificationList: [],
      displayAreaList: [
        {
          id: 1,
          title: '利用プラン',
          text: 'カメラ(かけつけ依頼)',
        },
        {
          id: 2,
          title: 'お客様番号',
          text: '51-1234567',
        },
        {
          id: 3,
          title: '警備先名',
          text: '警備先1',
        },
        {
          id: 4,
          title: '地区番号',
          text: '0001',
        },
        {
          id: 5,
          title: '地区名',
          text: '地区1',
        },
      ],
      disabledFlag: true,
      isHistoryVisible: true,
      disabledFlagArray: [],
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU25カメラ画面.カメラ'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU25カメラ画面.C0001'),
        tabs: [
          {
            id: 1,
            title: vm.$vuetify.lang.t('$vuetify.FECU25カメラ画面.カメラメニュー'),
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t('$vuetify.FECU25カメラ画面.通知履歴ボタン'),
          },
        ],
      };
    },
    footerToggle() {
      return this.$store.state.toggle;
    },
  },
  /** @type {Methods} */
  methods: {
    active: function () {
      this.isActive = !this.isActive;
    },
    tabSelect: function (num) {
      this.tabNumber = num;
    },
    /**
     * 初期化処理
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     */
    init: async function (queries, method) {
      // let param = "post"; // 検証用
      let param = '/api/common/getRoleList';
      const cu9916 = await this.APP_CU9916(param, queries, method);
      param = '/api/camera/fetchCameraList';
      const cu2501 = await this.APP_CU2501(param, queries, method);

      const cameraCount = cu2501.contentsInfo.cameraInfoList.length;
      this.$store.commit('setCameraTotal', {
        cameraTotal: cameraCount,
      });

      this.$store.state.cameraOneCountFlag = cameraCount === 1;
      if (cameraCount === 1) {
        this.goCameraDetail(cu2501.contentsInfo.cameraInfoList[0].deviceID);
      } else {
        let isHistoryVisible = false;
        // カメラ一覧マッピング
        cu2501.contentsInfo.cameraInfoList.forEach((element) => {
          // 権限の確認
          let cameraAuthority = true;
          let rushOrderAuthority = true;
          let notificationHistory = true;
          let contactAuthority = true;
          let deviceContorolAuthority = true;

          if (element.cameraUserType != 1) {
            cu9916.contentsInfo.cameraInfoList.forEach((cameraInfo) => {
              if (cameraInfo.deviceID === element.deviceID) {
                cameraAuthority = cameraInfo.userAuthority.anticrimeCameraVideos;
                rushOrderAuthority = cameraInfo.userAuthority.rushOrder;
                if (rushOrderAuthority && element.usagePlanId === 102) {
                  rushOrderAuthority = false;
                }
                notificationHistory = cameraInfo.userAuthority.notificationHistory;
                contactAuthority = cameraInfo.userAuthority.contact;

                isHistoryVisible = isHistoryVisible || cameraInfo.userAuthority.notificationHistory;

                if (
                  cameraInfo.userAuthority.notificationHistory == false &&
                  cameraInfo.userAuthority.nicknameSetting == false
                ) {
                  // #29840[機能修正管理表No.62] 各種設定ボタンが増えたので常に表示
                  //deviceContorolAuthority = false;
                }
              }
            });
          } else {
            if (element.usagePlanId === 102) {
              rushOrderAuthority = false;
            }
            isHistoryVisible = true;
          }

          let usagePlanName = '';
          switch (element.usagePlanId) {
            case 0:
              usagePlanName = '$vuetify.コード.利用プランID.オンライン監視プラン';
              break;
            case 101:
              usagePlanName = '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン';
              break;
            case 102:
              usagePlanName = '$vuetify.コード.利用プランID.カメラセルフ監視プラン';
              break;
            default:
              break;
          }

          this.cameraInfoList.push({
            id: element.deviceID,
            displayDistrictNickname: element.cameraNickname,
            displayDistrictUserType:
              element.cameraUserType === 1
                ? '$vuetify.FECU25カメラ画面.権限メインユーザー'
                : '$vuetify.FECU25カメラ画面.権限サブユーザー',
            cameraAuthority: cameraAuthority,
            rushOrderAuthority: rushOrderAuthority,
            notificationHistory: notificationHistory,
            contactAuthority: contactAuthority,
            deviceContorolAuthority: deviceContorolAuthority,
            //isDisabled: this.disabledFlagArray[element.deviceID],
            isDisabled: false, // #29840[機能修正管理表No.62] 各種設定ボタンが増えたので常に表示
            usagePlanName: usagePlanName,
          });
        });

        this.isHistoryVisible = isHistoryVisible;
      }

      // 通知履歴マッピング
      this.lastUpdate = cu2501.contentsInfo.lastUpdate.replace(/\..*/g, '');
      let allNotificationList = cu2501.contentsInfo.notificationList;
      let onlyOnce = false;
      allNotificationList.forEach((list) => {
        // 前回ログイン以降の通知 を表示
        if (!onlyOnce && list.isNewMessageLabel) {
          list.newMessageFromHere = true;
          onlyOnce = true;
        }
      });
      this.notificationList = allNotificationList;
    },
    /**
     * ユーザー権限一覧取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU9916: async function (param, queries, method) {
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: [
            //       {
            //         customerNumber: "1111111",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         userAuthority: {
            //           securityOperation: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           deviceContorol: true,
            //           contact: true,
            //           nicknameSetting: true,
            //           IDCardKeyInfoSetting: true,
            //           watchOverInfoDeliverySetting: true,
            //           lockUpCheck: true,
            //           targetAtHomeSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //     ],
            //     cameraInfoList: [
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "1",
            //         deviceID: "1111",
            //         cameraUserType: 1,
            //         userAuthority: {
            //           anticrimeCameraVideos: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           contact: true,
            //           nicknameSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "2",
            //         deviceID: "2222",
            //         cameraUserType: 2,
            //         userAuthority: {
            //           anticrimeCameraVideos: false,
            //           rushOrder: false,
            //           notificationHistory: false,
            //           contact: false,
            //           nicknameSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //   },
            // };

            for (let i = 0; i < apiData.contentsInfo.cameraInfoList.length; i++) {
              let userAuthority = apiData.contentsInfo.cameraInfoList[i].userAuthority;
              if (
                userAuthority.anticrimeCameraVideos === true ||
                userAuthority.rushOrder === true ||
                userAuthority.notificationHistory === true ||
                userAuthority.contact === true ||
                userAuthority.nicknameSetting === true ||
                userAuthority.userManagement === true ||
                userAuthority.emergencyContact === true
              ) {
                // その地区のユーザー権限で一つでもtrueがある場合、カメラ詳細画面に遷移できるようにする
                // this.disabledFlag = false;
                // break;
                this.disabledFlagArray[apiData.contentsInfo.cameraInfoList[i].deviceID] = false;
              } else {
                this.disabledFlagArray[apiData.contentsInfo.cameraInfoList[i].deviceID] = true;
              }
            }
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        );

      return apiData;
    },
    /**
     * カメラ一覧情報取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2501: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfoList: [
            //       {
            //         cameraNickname: "カメラ1",
            //         deviceID: "1111",
            //         districtSplitNumber: "1",
            //         cameraUserType: 1,
            //         usagePlanId: 0,
            //       },
            //       {
            //         cameraNickname: "カメラ2",
            //         deviceID: "2222",
            //         districtSplitNumber: "2",
            //         cameraUserType: 2,
            //         usagePlanId: 0,
            //       },
            //       {
            //         cameraNickname: "カメラ3",
            //         deviceID: "3333",
            //         districtSplitNumber: "3",
            //         cameraUserType: 2,
            //         usagePlanId: 0,
            //       },
            //     ],
            //     notificationList: [
            //       {
            //         notificationType: 1,
            //         postedName: "HOME ALSOK",
            //         postedDatetime: "2022-05-01 01:00:00",
            //         contentType: 1,
            //         serviceType: "N01",
            //         deviceID: "123456789",
            //         customerNumber: "11111-11111",
            //         securityDestinationName: "自宅",
            //         cameraNickname: "玄関カメラ",
            //         isPersonNotification: false,
            //       },
            //       {
            //         notificationType: 1,
            //         postedName: "HOME ALSOK",
            //         postedDatetime: "2022-05-01 06:00:00",
            //         contentType: 1,
            //         serviceType: "A10",
            //         deviceID: "123456789",
            //         customerNumber: "22222-22222",
            //         securityDestinationName: "自宅",
            //         cameraNickname: "リビングカメラ",
            //         isPersonNotification: false,
            //       },
            //       {
            //         notificationType: 1,
            //         postedName: "綜警 太郎",
            //         postedDatetime: "2022-05-20 12:00:00",
            //         contentType: 0,
            //         serviceType: "S05",
            //         deviceID: "123456789",
            //         customerNumber: "33333-33333",
            //         securityDestinationName: "自宅",
            //         cameraNickname: "2階窓カメラ",
            //         isPersonNotification: true,
            //       },
            //       {
            //         notificationType: 1,
            //         postedName: "HOME ALSOK",
            //         postedDatetime: "2022-05-30 20:00:00",
            //         contentType: 0,
            //         serviceType: "J07",
            //         deviceID: "123456789",
            //         customerNumber: "44444-44444",
            //         securityDestinationName: "祖父母宅",
            //         cameraNickname: "洗面所カメラ",
            //         isPersonNotification: false,
            //       },
            //     ],
            //     lastUpdate: "2022-05-30 12:00:00",
            //   },
            // };
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * ストアにデバイスIDを保存してカメラ詳細画面へ遷移
     * @param {*} deviceID デバイスID
     */
    goCameraDetail: function (deviceID) {
      this.$store.commit('setDeviceID', {
        deviceID: deviceID,
      });
      this.$router.push('/cameraDetail');
    },
    /**
     * ストアに(フッター)Toggle：trueを保存
     */
    onScroll() {
      this.$store.commit('setToggle', true);
    },
  },
  watch: {
    tabNumber(num) {
      this.$store.commit('setCameraTabNumber', { cameraTabNumber: num });
    },
  },
  created() {
    this.$store.commit('setToggle', false);
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
    this.tabNumber = this.$store.state.cameraTabNumber;
    this.$store.state.currentDisplayType = 2;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    // 正常系を確認したい場合は下記のコメントを解除する
    let method = 'post';
    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
    };

    await this.init(queries, method);
  },
};
